const debounce = {
  methods: {
    debounce(fn, delay) {
      var timeoutID = null
      return () => {
        clearTimeout(timeoutID)
        // eslint-disable-next-line prefer-rest-params
        const args = arguments
        const that = this
        timeoutID = setTimeout(() => {
          fn.apply(that, args)
        }, delay)
      }
    },
  },
}

export default debounce
